
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteDayBright as ObiPaletteDayBrightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-day-bright.js';
 
 
 

 
 export const ObiPaletteDayBright = createComponent({
   react: React,
   tagName: 'obi-palette-day-bright',
   elementClass: ObiPaletteDayBrightElement,
   events: {
     
   }
  });
 
 